// extracted by mini-css-extract-plugin
export var cardHeader = "_is-0";
export var reorderHandle = "_is-3";
export var titleArea = "_is-1";
export var titleAreaWithHandle = "_is-2";